export const msalConfig = {
    auth: {
       clientId: "7901f14d-2284-4e08-8524-16b29e6214c3",
       authority: "https://login.microsoftonline.com/505cca53-5750-4134-9501-8d52d5df3cd1",
       redirectUri: "https://secnav.daimlertruck.com",
       
    //   clientId: "c455b7db-e7b1-4984-9492-d86bb8b80f65",
    //   authority: "https://login.microsoftonline.com/109df8d7-a6c9-4c33-b132-5fb544822857", 
    //  redirectUri: "https://aztestactions.azurewebsites.net",
    //  redirectUri: "http://localhost:3000",
     

    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };
  
  // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
  export const loginRequest = {
    scopes: ["7901f14d-2284-4e08-8524-16b29e6214c3/.default"]
    // scopes: ["c455b7db-e7b1-4984-9492-d86bb8b80f65/.default"]

  };
